module.exports = __webpack_public_path__ + "img/jbt3411_94_1999.prt.cdf10379.jpg";